module.exports = __webpack_public_path__ + "7e122eebdd29778d4082981e7f3763f9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-22.png
// module id = 3318
// module chunks = 0